import Navigation from './components/Navigation';
import searchToggle from './components/searchToggle';

new Navigation();
searchToggle.init();
